
<!-- sign-in -->
<p-dialog
  [(visible)]="show_dialog_box"
  [modal]="true"
  [resizable]="false"
  [dismissableMask]="true"
  [blockScroll]="true"
  [closable]="true"
  [breakpoints]="{'1250px': '75vw', '640px': '90vw'}" 
  [style]="{width: '50vw'}"
  closeIcon=""
  class="text-center"
  (onHide)="close_auth_modal();"
>


   <div class="d-flex flex-column align-items-center">
      

      <ng-template pTemplate="header">
      </ng-template>


      <div class="d-flex flex-column align-items-center gap-3 w-100">

         <div>
            <img 
            src="https://www.elmenus.com/public/img/svg-icons/motorcycle-delivery-colored1.svg"
            width="200"
            height="100"
            >
         </div>

         <div>
            <p class="fs-4 fw-bold">{{  "area_modal_title" | translate: "header" }}</p>
         </div>

      </div>



      <div class="border-top d-flex mt-3 w-100 branches-contailer">
         
         <div class="col-6 box-1">

            <div class="flex-column loccations-blocks-container">
            
               <!-- cell -->
               <lib-branches-modal-cell [vendor_branches]="vendor_branches"></lib-branches-modal-cell>
            
            </div>

         </div>

         <div class="py-5 d-flex flex-column align-items-center gap-3 col-6  box-2">

            <div class="location-img">
               <img src="https://www.elmenus.com//public/img/locationArrow.png" class="arrowImg" width="120" height="60"> 
               <img src="https://www.elmenus.com//public/img/locationPin.png" class="pinImg" width="80" height="110">
            </div>

            <div>
               <p class="fs-6 fw-bold">{{ "area_modal_sub_title" | translate: "header" }}</p>
            </div>


         </div>

      </div>


   </div>


</p-dialog>

